export default __webpack_public_path__ + "static/media/contactTeams.6611211d.svg";